<template>
  <div class="loader-box d-flex justify-content-center">
    <div class="loader">
      <div class="line bg-primary"></div>
      <div class="line bg-primary"></div>
      <div class="line bg-primary"></div>
      <div class="line bg-primary"></div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "loading"
  }
</script>

<style scoped>

</style>
